import { createRoute, useParams } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const InspectionRunView = lazy(async () => {
  const m = await import("@/features/inspections/components/inspection-run-view");
  return { default: m.InspectionRunView };
});

export interface InspectionRunSearch {
  /**
   * Deep-link: 1-based index of the active checklist section (carousel). Stored as
   * a string so it shares the `section` search-param shape with other routes.
   */
  section?: string;
  /** Deep-link: open the signature dialog to complete the inspection. */
  dialog?: string;
  /** Deep-link: open the "new finding" dialog — `new`, optionally scoped to an item. */
  finding?: string;
  /** Deep-link: the template item the new finding is being raised against. */
  itemId?: string;
}

/** Normalise a 1-based positive-integer section param; otherwise `undefined`. */
function toSectionParam(value: unknown): string | undefined {
  const n = typeof value === "number" ? value : Number(value);
  return Number.isInteger(n) && n >= 1 ? String(n) : undefined;
}

function InspectionRunPage() {
  const params = useParams({ from: "/_app/inspections/$inspectionId" });
  return (
    <Suspense fallback={null}>
      <InspectionRunView inspectionId={params().inspectionId} />
    </Suspense>
  );
}

export const inspectionDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/inspections/$inspectionId",
  validateSearch: (search: Record<string, unknown>): InspectionRunSearch => ({
    section: toSectionParam(search.section),
    dialog: search.dialog === "sign" ? "sign" : undefined,
    finding: search.finding === "new" ? "new" : undefined,
    itemId: typeof search.itemId === "string" ? search.itemId : undefined,
  }),
  component: InspectionRunPage,
});
